module.exports = "<app-cash-list></app-cash-list>"